// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ke-j","checkboxCol":"Table_checkboxCol__vyWYy","emailCol":"Table_emailCol__1FvKa","actionCol":"Table_actionCol__1rrpq"};